import { Translation } from '@shared/types/translation';

export const CLIENT_PERMISSION_LABELS = {
  SELECT_ALL: {
    english: 'Select All',
    polish: 'Zaznacz wszystko',
  },

  FACILITY_MANAGEMENT: {
    english: 'Facility Management',
    polish: 'Zarządzanie placówkami',
  },
  LIST_OF_FACILITIES: {
    english: 'List of Facilities',
    polish: 'Lista placówek',
  },
  CREATE_FACILITY: {
    english: 'Create Facility',
    polish: 'Tworzenie placówki',
  },
  EDIT_FACILITY: {
    english: 'Edit Facility',
    polish: 'Edycja placówki',
  },
  ACTIVATE_DEACTIVATE_FACILITY: {
    english: 'Activate/Deactivate Facility',
    polish: 'Aktywuj / Dezaktywuj placówkę',
  },
  VIEW_LIST_OF_FACILITIES: {
    english: 'View List of Facilities',
    polish: 'Lista placówek',
  },
  VIEW_SPECIFIC_FACILITY_DETAILS: {
    english: 'View Specific Facility Details',
    polish: 'Podgląd szczegółów placówki',
  },

  EQUIPMENT_MANAGEMENT: {
    english: 'Equipment Management',
    polish: 'Zarządzanie aparaturą',
  },
  ADD_EQUIPMENT: {
    english: 'Add Equipment',
    polish: 'Dodaj aparaturę',
  },
  EDIT_EQUIPMENT_DETAILS: {
    english: 'Edit Equipment Details',
    polish: 'Edycja danych aparatury',
  },
  VIEW_EQUIPMENT_LIST: {
    english: 'View Equipment List',
    polish: 'Lista aparatury',
  },
  VIEW_EQUIPMENT_DETAILS: {
    english: 'View Equipment Details',
    polish: 'Podgląd danych aparatury',
  },
  ACTIVATE_DEACTIVATE_EQUIPMENT: {
    english: 'Activate/Deactivate Equipment',
    polish: 'Aktywacja / dezaktywacja aparatury',
  },

  FACILITY_USER_MANAGEMENT: {
    english: 'Facility User Management / Employees',
    polish: 'Zarządzanie użytkownikami placówki',
  },
  ADD_FACILITY_USER: {
    english: 'Add Facility User',
    polish: 'Dodawanie użytkownika placówki',
  },
  EDIT_FACILITY_USER: {
    english: 'Edit Facility User',
    polish: 'Edycja użytkownika placówki',
  },
  VIEW_FACILITY_USER_LIST: {
    english: 'View Facility User List',
    polish: 'Lista użytkowników placówki',
  },
  VIEW_FACILITY_USER_DETAILS: {
    english: 'View Facility User Details',
    polish: 'Podgląd danych użytkownika placówki',
  },
  ACTIVATE_DEACTIVATE_FACILITY_USER: {
    english: 'Activate / Deactivate Facility User',
    polish: 'Aktywacja / dezaktywacja użytkownika placówki',
  },

  SERVICE_REQUEST_MANAGEMENT: {
    english: 'Service Request Management',
    polish: 'Zarządzanie zgłoszeniami serwisowymi',
  },
  CREATE_SERVICE_REQUEST: {
    english: 'Create Service Request',
    polish: 'Tworzenie zgłoszenia serwisowego',
  },
  VIEW_SERVICE_REQUEST_LIST: {
    english: 'View Service Request List',
    polish: 'Lista zgłoszeń serwisowych',
  },
  VIEW_SPECIFIC_SERVICE_REQUEST: {
    english: 'View Specific Service Request',
    polish: 'Podgląd zgłoszenia serwisowego',
  },
  CANCEL_SERVICE_REQUEST: {
    english: 'Cancel Service Request',
    polish: 'Anulowanie zgłoszenia serwisowego',
  },

  QMS_DOCUMENT_MANAGEMENT: {
    english: 'QMS Document Management',
    polish: 'Zarządzanie dokumentami SZJ',
  },
  LIST_ALL_QMS_DOCUMENTS: {
    english: 'List All QMS Documents',
    polish: 'Lista dokumentów SZJ',
  },
  VIEW_SPECIFIC_QMS_DOCUMENT: {
    english: 'View Specific QMS Document',
    polish: 'Podgląd dokumentu SZJ',
  },
  DOWNLOAD_QMS_DOCUMENTS: {
    english: 'Download QMS Documents',
    polish: 'Pobieranie dokumentów SZJ',
  },
  SHARE_QMS_DOCUMENTS: {
    english: 'Share QMS Documents',
    polish: 'Udostępnianie dokumentów SZJ',
  },
  REQUEST_CHANGE_IN_QMS_DOCUMENT: {
    english: 'Request Change in QMS Document',
    polish: 'Zgłoszenie zmiany w dokumencie SZJ',
  },

  CERTIFICATE_MANAGEMENT: {
    english: 'Certificate Management',
    polish: 'Zarządzanie certyfikatami',
  },
  LIST_CERTIFICATES: {
    english: 'List Certificates',
    polish: 'Lista certyfikatów',
  },
  DOWNLOAD_CERTIFICATE: {
    english: 'Download Certificate',
    polish: 'Pobieranie certyfikatu',
  },

  INVOICE_MANAGEMENT: {
    english: 'Invoice Management',
    polish: 'Zarządzanie fakturami',
  },
  LIST_INVOICES: {
    english: 'List Invoices',
    polish: 'Lista faktur',
  },
  VIEW_SPECIFIC_INVOICE: {
    english: 'View Specific Invoice',
    polish: 'Podgląd faktury',
  },
  DOWNLOAD_INVOICE: {
    english: 'Download Invoice',
    polish: 'Pobieranie faktury',
  },

  OTHERS: {
    english: 'Others',
    polish: 'Pozostałe',
  },
  VIEW_DASHBOARD: {
    english: 'View Dashboard',
    polish: 'Podgląd panelu głównego',
  },
  VIEW_SUPPORT_CONTACT_DETAILS: {
    english: 'View Support Contact Details',
    polish: 'Podgląd danych kontaktowych wsparcia',
  },
  CONTACT_REQUEST: {
    english: 'Contact Request',
    polish: 'Tworzenie zgłoszenia kontaktowego',
  },
} as const satisfies Record<string, Translation>;

export const CLIENT_LABELS = {
  VIEW_CLIENT_TITLE: {
    english: 'View Client',
    polish: 'Podgląd klienta',
  },
} as const satisfies Record<string, Translation>;
